export default __webpack_public_path__ + "static/CircularStd-BookItalic-a50214c5394dacd2dfc91800b1ee25cf.ttf";